import { setDefaultOptions } from "date-fns";
import i18next, { use } from "i18next";
import { initReactI18next } from "react-i18next";
import { LocalSettingKey, getLocalSetting } from "core/localSettings";
import type { PostProcessorModule, Resource } from "i18next";
import { getDateFnsLocale, getLocale, resources } from "./i18nResources";

// Runs after i18next resolves a value. When the "show translation keys" toggle
// is on it discards the resolved text and returns the requested key instead, so
// a content person can see which key maps to what on screen.
const showKeysPostProcessor: PostProcessorModule = {
  type: "postProcessor",
  name: "showKeys",
  process: (value, key) => {
    if (!getLocalSetting(LocalSettingKey.ShowTranslationKeys)) return value;
    return Array.isArray(key) ? key[0] : key;
  },
};

// This is NOT a react hook 🤒
// eslint-disable-next-line react-hooks/rules-of-hooks
use(initReactI18next) // passes i18n down to react-i18next
  .use(showKeysPostProcessor)
  .init({
    resources: resources as Resource,
    lng: getLocale(),
    interpolation: {
      escapeValue: false,
    },
    fallbackLng: "en",
    returnEmptyString: false, // instead fallback to en
    postProcess: ["showKeys"],
  });

const dateLocale = getDateFnsLocale();
setDefaultOptions({ locale: dateLocale });

export { i18next };
